import { render, staticRenderFns } from "./DeletionOrchestratorStatus.vue?vue&type=template&id=2967f2c7&scoped=true&"
import script from "./DeletionOrchestratorStatus.vue?vue&type=script&lang=ts&"
export * from "./DeletionOrchestratorStatus.vue?vue&type=script&lang=ts&"
import style0 from "./DeletionOrchestratorStatus.vue?vue&type=style&index=0&id=2967f2c7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2967f2c7",
  null
  
)

export default component.exports